/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import { ReactComponent as ArrowIcon } from '../../resources/images/arrow-right.svg';
import { ReactComponent as CardIcon } from '../../resources/images/credit-card-02.svg';
import UCButton from "../buttons";

/* Styles */
import styles from "./styles.js"

const AuthorisedCardUsersNotice = ({title, description, button, handleButton}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={ classes.notificationContainer }>
        <div className={ classes.icon }>            
            <CardIcon />
        </div>
        <div>
            <div className={ classes.title }>
                {title}
            </div>
            <div className={ classes.description }>
                {description}
            </div>
            <UCButton
                type="defaultLink"
                className={classes.button}
                text={button}
                onClick={handleButton}
                children={<ArrowIcon/>}
            />
        </div>
    </div>
  )
}

export default AuthorisedCardUsersNotice;
